import { classnames } from 'tailwindcss-classnames';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { DesktopTabsProps, TabProps } from './_types';

export const DesktopVerticalTabsLayout = ({
  fields,
  rendering,
  visibleItem,
  toggleItemVisibility,
}: DesktopTabsProps) => {
  const categories = fields?.tabsItems as TabProps[];
  const noCategories = !categories || categories.length === 0;
  return (
    <>
      {noCategories && <span>Add a tab to get started.</span>}
      <div className={classnames('grid', 'grid-cols-4', { hidden: noCategories })}>
        <div className={classnames(`border-r`, `border-solid`, `border-gray-midGray`)}>
          <ul data-nmdp-tabstrip="tabstrip">
            {categories.map((item) => (
              <li
                key={item.id}
                className={classnames(`py-[17px]`, `pl-[14px]`, `pr-[9px]`, {
                  ['bg-gray-whisper']: item.id === visibleItem,
                  ['border-l-8']: item.id === visibleItem,
                  ['border-solidBlack']: item.id === visibleItem,
                })}
              >
                <button
                  type="button"
                  className={classnames(`w-full`, `text-left`, `font-semibold`, `cursor-pointer`)}
                  data-nmdp-tab={item?.id}
                  onClick={() => toggleItemVisibility(item?.id)}
                >
                  <div className={classnames(`w-[95%]`)}>
                    <h3
                      className={classnames(`mb-[3px]`, `text-body`, `font-medium`, `leading-9`, {
                        'text-solidBlack': item.id === visibleItem,
                      })}
                    >
                      {item?.displayName}
                    </h3>
                  </div>
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className={classnames('col-span-3', 'pl-5')}>
          {categories.map((item, index) => (
            <div
              key={item.id}
              className={classnames('w-full', 'h-full', {
                hidden: visibleItem !== item.id,
              })}
              data-nmdp-tab={index}
            >
              <PlaceholderWrapper
                name={`nmdp-tabs-content-${String.fromCharCode(index + 97)}`}
                rendering={rendering}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
